import { AutogenLayoutTableSettlementMultiCurrency } from "./autogen/AutogenLayoutTableSettlementMultiCurrency";

export class TableSettlementMultiCurrency extends AutogenLayoutTableSettlementMultiCurrency {

    private _displayCurrencys: boolean = true;

    syncColumns() {
        const columnCurrency = this.tableMulticurrency.columns.find(c => c.headingCell.id === "columnCurrency");
        this.tableMulticurrency.setColumnVisibility(columnCurrency, this._displayCurrencys);
    }
}
